/**
 *首页 vm
 *@author xujinjiang
 *@date 2022/3/1 17:35
 */
import { BaseViewModel } from '@/viewmodel/BaseViewModel';
import { ObserverService } from '@/service/ObserverService';
import { CommonUtil } from '@/utils/CommonUtil';
import { AuditLogServiceImpl } from '@/service/AuditLogServiceImpl';
import { actionType } from '@/constant/ActionType';

export class HomeViewModel extends BaseViewModel {
  private loginRecordList: any = [];
  private userSubscription: any;
  public user: any = [];
  pageNo = 1;
  pageSize = 10;
  private showAppKeySecret = false;
  tableHeight = window.innerHeight - 525;
  homeLoadig: any;
  loading: any;
  showTable = false;

  created() {
    this.initObserver();
  }

  mounted() {
    this.loading = CommonUtil.loading('.table-div');
    window.addEventListener('resize', () => {
      this.tableHeight = window.innerHeight - 525;
    });
  }

  unmounted() {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }

  private initObserver() {
    this.userSubscription = ObserverService.getInstance()
      .getUserObserver()
      .subscribe((userInfo: any) => {
        if (!userInfo) {
          return;
        }
        this.user = userInfo;
        this.initData();
      });
  }

  private initData() {
    this.getLoginRecordList().then();
  }

  private async getLoginRecordList() {
    try {
      const result: any = await AuditLogServiceImpl.getInstance().getAuditLogList(
        actionType.login.englishTitle,
        this.pageNo,
        this.pageSize
      );
      this.loginRecordList = result.result;
      this.showTable = true;
      this.loading.close();
    } catch (e) {
      console.error('获取用户登录记录：', e);
      this.loginRecordList = [];
      this.showTable = true;
      this.loading.close();
    }
  }

  getPercentage(percentage: any) {
    return percentage ? (percentage === 100 ? percentage : percentage.toFixed(2)) : 0;
  }

  getAddress(data: any) {
    const address = CommonUtil.checkEmpetyProvince(data.province, data.city, data.area);
    return address;
  }

  getIp(scop: any) {
    return scop.row.ip.indexOf(',') > 0
      ? scop.row.ip.substring(0, scop.row.ip.indexOf(','))
      : scop.row.ip;
  }

  /**
   * 查看完整令牌
   */
  showFullKey() {
    this.showAppKeySecret = true;
  }

  getClientInfo(scop: any) {
    // todo 设备类型待定
    return 'OMS';
  }
}
